import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const HeartIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M14.325 2.01C12.519.49 9.728.718 8 2.477 6.272.718 3.481.488 1.675 2.01c-2.35 1.978-2.006 5.204-.331 6.913l5.481 5.584a1.638 1.638 0 0 0 2.35.003l5.481-5.584c1.672-1.71 2.022-4.934-.331-6.916Zm-.737 5.859-5.482 5.584c-.075.075-.137.075-.212 0L2.413 7.87c-1.141-1.163-1.372-3.363.228-4.71 1.215-1.021 3.09-.868 4.265.329L8 4.603l1.094-1.115c1.181-1.204 3.056-1.35 4.265-.332 1.597 1.347 1.36 3.56.229 4.713Z"/>
    </svg>
);
HeartIcon.displayName = 'HeartIcon';
export default HeartIcon;
